import '../../styles/ui/ui.scss'
import { motion } from 'framer-motion';

const Title = ({text}) => (
    <motion.div className="header-title"
        initial={{
            x: '-100%',
            opacity: 0
        }}
        animate={{
            x: '0%',
            opacity: 1
        }}
        transition={{
            ease: "easeOut",
            duration: 0.5
        }}
    >
        <h1>
            {text}
        </h1>
    </motion.div>
)

export default Title;